import type { SmriqContext, SmriqPlanSettings } from '../types/smriq.types';

type PlanSettingsDefaults = Pick<SmriqPlanSettings, 'duration_months' | 'include_mot_tests'>;

/** The duration and MOT choice a regenerate can reuse: the quote's own settings, else the
 *  product defaults. Null when either is still unknown. */
export const resolvePlanSettingsDefaults = (
    settings: SmriqPlanSettings | null | undefined,
    context: SmriqContext | undefined,
): PlanSettingsDefaults | null => {
    const duration = settings?.duration_months ?? context?.duration.default;
    const includeMot = settings?.include_mot_tests ?? context?.mot.default;
    if (duration == null || includeMot == null) return null;
    return { duration_months: duration, include_mot_tests: includeMot };
};
